import { AuthGuard } from './shared/services/b2b/auth.guard';
import { ModuleWithProviders } from '@angular/core';
import { PageNotFoundComponent } from './404/404.component';
import { ProductInfoPrintComponent } from './product-info-print/product-info-print.component';
import { RouterModule } from '@angular/router';
import { StyleGuideComponent } from './style-guide/style-guide.component';
import { RouterStateSerializer } from '@ngrx/router-store';
import { CustomSerializer } from './store/router/router.state';
import { TestComponent } from './shared/lib/components/test/test.component';
import { AppModule } from './app.module';

export const appRoutingProviders: any[] = [{ provide: RouterStateSerializer, useClass: CustomSerializer }];

export const appRouting: ModuleWithProviders<AppModule> = RouterModule.forRoot(
    [
        {
            path: '',
            redirectTo: 'login',
            pathMatch: 'full',
        },
        {
            path: 'index.html',
            redirectTo: 'login',
        },
        {
            path: 'index_debug.html',
            redirectTo: 'login',
        },
        {
            path: 'style-guide',
            component: StyleGuideComponent,
        },
        {
            path: 'product-print-new/:carga/:velocidad/:provider/:ancho/:perfil/:llanta/:agarre/:consumo/:ruido/:etiquetado2/:marca/:onda/:hielo/:nieve/:qr/:nombre',
            component: ProductInfoPrintComponent,
        },
        {
            path: 'product-print/:agarre/:consumo/:ruido/:etiquetado2/:marca/:nombre',
            component: ProductInfoPrintComponent,
        },
        {
            path: 'dashboard',
            loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashBoardModule),
            canActivate: [AuthGuard],
        },
        {
            path: 'test',
            component: TestComponent,
        },
        {
            path: 'page-not-found',
            component: PageNotFoundComponent,
        },
        {
            path: '**',
            component: PageNotFoundComponent,
        },
    ],
    {
        onSameUrlNavigation: 'reload',
    }
);
